export default "__VITE_ASSET__BlEr$VzC__"